import Cookies from 'js-cookie';
import { showBanNotification, BanType } from '@/ui/BanNotification';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

async function request(path: string, method: HttpMethod, body?: any, csrfToken?: string) {
  const headers: Record<string, string> = { 'Accept': 'application/json' };
  let payload: BodyInit | undefined;
  if (body && !(body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    payload = JSON.stringify(body);
  } else if (body instanceof FormData) {
    payload = body;
  }
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken;

  const res = await fetch(path, {
    method,
    headers,
    body: payload,
    credentials: 'include'
  });
  
  // Handle rate limiting and bans
  if (res.status === 429 || res.status === 403) {
    const contentType = res.headers.get('content-type') || '';
    if (contentType.includes('application/json')) {
      try {
        const data = await res.json();
        const retryAfter = parseInt(res.headers.get('Retry-After') || data.retry_after || '0');
        
        let banType: BanType = 'rate_limited';
        let message = 'Kısa süre içinde çok fazla istek gönderdiniz. Sunucumuzu korumak için geçici olarak yavaşlatıldınız. Lütfen birkaç saniye bekleyip tekrar deneyin.';
        
        if (data.error === 'Forbidden' || data.error === 'Temporarily Blocked') {
          if (data.message?.includes('permanently')) {
            banType = 'permanent_ban';
            message = 'IP adresiniz, sunucumuza yönelik şüpheli veya kötü niyetli aktivite tespit edilmesi nedeniyle kalıcı olarak engellenmiştir. Bu kararın hatalı olduğunu düşünüyorsanız bizimle iletişime geçebilirsiniz.';
          } else {
            banType = 'temp_ban';
            message = 'IP adresiniz, aşırı sayıda istek göndermeniz nedeniyle geçici olarak engellenmiştir. Bu durum genellikle otomatik araçlar veya botlar kullanıldığında ortaya çıkar. Engel süresi dolduğunda normal şekilde siteyi kullanmaya devam edebilirsiniz.';
          }
        } else if (data.error === 'Too Many Requests') {
          message = 'Kısa süre içinde çok fazla istek gönderdiniz. Sunucumuzu korumak için geçici olarak yavaşlatıldınız. Lütfen birkaç saniye bekleyip tekrar deneyin.';
        }
        
        showBanNotification(banType, message, retryAfter);
        throw new Error(data.message || data.error);
      } catch (e) {
        if (e instanceof Error && e.message !== 'Unexpected end of JSON input') {
          throw e;
        }
      }
    }
  }
  
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || res.statusText);
  }
  const contentType = res.headers.get('content-type') || '';
  if (contentType.includes('application/json')) return res.json();
  return res.text();
}

export const api = {
  get: (path: string) => request(path, 'GET'),
  post: (path: string, body: any, csrfToken?: string) => request(path, 'POST', body, csrfToken),
  put: (path: string, body: any, csrfToken?: string) => request(path, 'PUT', body, csrfToken),
  del: (path: string, body?: any, csrfToken?: string) => request(path, 'DELETE', body, csrfToken),
  upload: (path: string, form: FormData, csrfToken?: string) => request(path, 'POST', form, csrfToken)
};

export function getCsrfToken() {
  return Cookies.get('csrf_token');
}
